import { render, staticRenderFns } from "./import-data.vue?vue&type=template&id=6f62b89f&"
import script from "./import-data.vue?vue&type=script&lang=js&"
export * from "./import-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports